import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, defineMessages } from 'react-intl';

import Header from '../../../components/page-layout/header';
import Title from '../../../components/page-layout/title';
import TitleSection from '../../../components/page-layout/title-section';

const messages = defineMessages({
  headerTitle: {
    description: 'batchesList.title',
    defaultMessage: 'Batches / {selectedTab}',
    id: 'zLsM6d',
  },
});

const convertFirstCharToUpperCase = (value) => value.charAt(0).toUpperCase() + value.slice(1);

const BatchesListPageHeader = ({ selectedTab }) => (
  <Header>
    <TitleSection>
      <Title>
        <FormattedMessage {...messages.headerTitle} values={{ selectedTab: convertFirstCharToUpperCase(selectedTab) }} />
      </Title>
    </TitleSection>
  </Header>
);

BatchesListPageHeader.propTypes = {
  selectedTab: PropTypes.string.isRequired,
};

export default BatchesListPageHeader;
